const isSameKeyPath = (keyPath1, keyPath2) => keyPath1.every(
  (element, index) => keyPath2[index] && keyPath2[index].key === element.key && keyPath2[index].type === element.type
);
export {
  isSameKeyPath
};
//# sourceMappingURL=isSameKeyPath.mjs.map